// extracted by mini-css-extract-plugin
export var category = "_js-9";
export var categoryHeader = "_js-e";
export var container = "_js-0";
export var group = "_js-a";
export var groupItems = "_js-f";
export var groupSeparator = "_js-j";
export var loading = "_js-1";
export var noResults = "_js-3";
export var placeholder = "_js-2";
export var resultContent = "_js-5";
export var resultIcon = "_js-c";
export var resultItem = "_js-g";
export var resultMeta = "_js-8";
export var resultSubtitle = "_js-7";
export var resultSuffix = "_js-i";
export var resultTitle = "_js-6";
export var resultsList = "_js-4";
export var searchGroup = "_js-d";
export var selected = "_js-h";
export var subgroup = "_js-b";